export const Environment =
{
    ApiUri: "/api",
    DxLicenseKey: "ewogICJmb3JtYXQiOiAxLAogICJjdXN0b21lcklkIjogIjFjOTZlNDc3LWM2ZDItMTFlNC04MGM0LTAwMjU5MGQ5ZDVmZiIsCiAgIm1heFZlcnNpb25BbGxvd2VkIjogMjUyCn0=.GDpRCIHf1yP4YH2oRdSxXhHHb1SAlMbVsy9Z3r61eFQKGLNT+a89SbJyJN7vwHyM5JPdtfHgDe0D4rV8wmOAjUN0WIzHahPXFKrZw0VVMB7lsIHkinccrjQoljPyyd1IAHEoOQ==",
};
